
import LazyImage from '@/components/lazy-image';
import Button from '@/ui-kit/components/button';
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ImageHelper from '@/utils/ImageHelper';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { Comparator } from '@/ui-kit/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';
import routes from '@/constants/routes';
import BuySellYourHomeSection from '../section';
import { ImageSize } from './enums';
import { track } from '@/utils/analytics';

export default {
  name: 'SellYourHomeFooterSection',
  components: {
    Button,
    LazyImage,
    BuySellYourHomeSection,
    Typography,
  },
  mixins: [WindowSize],
  props: {
    storeName: {
      type: String,
      required: true,
    },
    trackEvent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      StylePositionType,
      StyleColorSchemeType,
      StyleSizeType,
      routes,
      ImageSize,
      TypographyType,
    };
  },
  computed: {
    footerContent() {
      return this.$store.state[this.storeName].footerContent;
    },
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(
        this.footerContent.footerData.image.dimensions,
      );
    },
    footerImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: this.breakpoints.Small,
          imageSize: ImageSize.Small,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: this.breakpoints.Medium,
          imageSize: ImageSize.Large,
        },
      ];
    },
  },
  methods: {
    trackButton(event, text) {
      track(`${event}${text} button click`);
    },
  },
};
